import { ContactResult, ContactResultType } from "./ContactResult";

/** HTTP response payload shape for a contact result.
 * @remarks Intentionally uses legacy API field names (`opportunityId`, `customerId`).
 * Use {@link toDomainContactResult} to map to the domain model.
 */
export interface ContactResultResponse {
  id?: string;
  appointmentId?: string;
  /** @remarks Intentionally using `customerId` to match the backend API. Maps to {@link ContactResult.customerId}. */
  customerId: string;
  /** @remarks Intentionally using `opportunityId` to match the backend API. Maps to {@link ContactResult.leadId}. */
  opportunityId: string;
  type: ContactResultType;
  disqualifyingReasons: Record<string, boolean>;
}

/** Maps an HTTP {@link ContactResultResponse} to the {@link ContactResult} domain model. */
export const toDomainContactResult = (response: ContactResultResponse): ContactResult => {
  const result = new ContactResult(response.customerId, response.opportunityId, response.type, response.appointmentId);
  result.id = response.id;
  result.disqualifyingReasons = response.disqualifyingReasons;
  return result;
};
